import {createContext, FC, ReactNode, useState} from 'react'
import {WarningModal} from './ui'

export type WarningModalProps = {
  header?: string | ReactNode
  text?: string | ReactNode
}

export type WarningModalContextType = WarningModalProps & {
  setWarningModal: (params: WarningModalProps) => void
}

export const WarningModalContext = createContext<WarningModalContextType | null>(null)

export const WarningModalProvider: FC<{children: ReactNode}> = ({children}) => {
  const [config, setConfig] = useState<WarningModalProps>({
    header: undefined,
    text: undefined,
  })

  const setWarningModal = (params: WarningModalProps) => {
    setConfig((prevState) => ({...prevState, header: params.header, text: params.text}))
  }

  return (
    <WarningModalContext.Provider value={{...config, setWarningModal}}>
      <WarningModal />
      {children}
    </WarningModalContext.Provider>
  )
}